import { useEffect, useRef } from 'react';
import { applyGeopolygonThumbnail } from '../utils/generateGeopolygonMapThumbnail';

/**
 * Generate a sidebar map preview when a geopolygon ring is present; remove it
 * when the polygon is cleared.
 */
export function useGeopolygonThumbnail(
  ring: number[][] | undefined,
  geoPolygonImage: string,
  setGeoPolygonImage: (value: string) => void,
): void {
  const generationId = useRef(0);
  const ringKey = ring ? JSON.stringify(ring) : '';

  useEffect(() => {
    if (!ring || ring.length < 3) {
      if (geoPolygonImage !== '') {
        setGeoPolygonImage('');
      }
      return;
    }

    const id = ++generationId.current;

    applyGeopolygonThumbnail(ring)
      .then((img) => {
        if (id === generationId.current) {
          setGeoPolygonImage(img);
        }
      })
      .catch((err) => {
        console.warn('Could not generate geopolygon map preview:', err);
      });

    return () => {
      generationId.current += 1;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ring content tracked by ringKey
  }, [ringKey, geoPolygonImage, setGeoPolygonImage]);
}
